module.exports = __webpack_public_path__ + "static/media/packing-list.a2653d2f.jpg";